import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type Error as SchemaError } from '../schemas/Error';
import { type PromocodeGroupSetDeactivatedResponseBody as SchemaPromocodeGroupSetDeactivatedResponseBody } from '../schemas/PromocodeGroupSetDeactivatedResponseBody';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @description Устанавливает флаг deactivated у группы промокодов
 * @tags PromocodeGroups
 * @summary Активация/деактивация группы промокодов
 */
export const PromocodeGroupSetDeactivatedContentType = 'application/json' as const;
export type PromocodeGroupSetDeactivatedRequest = {
    /**
     * @description Флаг деактивации
     * @example true
     */
    deactivated: boolean;
};
export type PromocodeGroupSetDeactivatedResponses = LinkCommonErrorResponses & {
    /**
     * @description Запрос обработан
     */
    '200': {
        'application/json': SchemaPromocodeGroupSetDeactivatedResponseBody;
    };
    /**
     * @description Not found
     */
    '404': {
        'application/json': SchemaError;
    };
};
export type PromocodeGroupSetDeactivatedResponseSuccess =
    PromocodeGroupSetDeactivatedResponses['200']['application/json'];
export type PromocodeGroupSetDeactivatedSearchParams = undefined;
export type PromocodeGroupSetDeactivatedPathParameters = {
    id: string;
};
export const PromocodeGroupSetDeactivatedUrl = '/promocode_groups/{id}/deactivate' as const;
export const PromocodeGroupSetDeactivatedMethod = 'PATCH' as const;
export const getPromocodeGroupSetDeactivatedUrl = (params: PromocodeGroupSetDeactivatedPathParameters) =>
    PromocodeGroupSetDeactivatedUrl.replace(
        /\{(\w+)\}/g,
        (_match, param: keyof PromocodeGroupSetDeactivatedPathParameters) => String(params[param])
    );
